<template>
  <div class="modal fade slide-right"
       id="confirmModal"
       role="dialog"
       aria-hidden="true"
       data-backdrop="static">
    <div class="modal-dialog modal-sm modal-payment"
         style="width:500px;">
      <div class="modal-content-wrapper">
        <div class="modal-content"
             style="width:500px;height:100%;">
          <div class="modal-header text-left">
            <button type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-hidden="true">
              <i class="pg-close fs-14"
                 @click="$emit('close-modal')"></i>
            </button>
            <div class="modal-left">
              <h2 class="modal-title" v-if="status != 'closed'">Modification du statut d'un Lead</h2>
              <h2 class="modal-title" v-else>Fermeture d'un Lead</h2>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-right">
              <!-- <notifications v-if="is_any_errors"
                             :errors="errors"
                             @close-error="reset_error($event)"
                             >
              </notifications> -->

              <div v-if="status == 'closed'">
                <p>Pour cloturer un lead, veuillez entrer les raisons de cette action dans le champs ci-dessous:</p>
                <div class="form-group tip">
                  <custom-select :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="selected_closing_reason = $event.new_value ? $event.new_value.value : 8">
                  </custom-select>
                </div>
                <div class="form-group tip">
                  <label>Commentaire (optionel, max 255 caractères)</label>
                  <custom-text-area :field="fields[1]" :value="fields[1].value" :field_idx="1" @field-updated="filled_closing_reason = $event.new_value">
                  </custom-text-area>
                </div>
              </div>

              <div v-else-if="status == 'duplicate'">
                <p>Merci de renseigner l'ID du lead principal (dont ce lead est un doublon)</p>
                <div class="form-group tip" >
                  <custom-text :field="fields[2]" :value="fields[2].value" :field_idx="2" @field-updated="lead_duplicate_id = $event.new_value">
                  </custom-text>
                </div>
              </div>

              <div v-else>
                <p>Etes vous sur de vouloir modifier l'etat de ce lead ?</p>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <div v-if="is_any_errors">
                <p class="label label-success" v-for="(error, idx) in normalizedErrors" :key="'error_' + idx">
                    {{ error }}
                </p>
            </div>
            <button class="btn btn-complete btn-cons" @click="update_status"
                    >Confirmer</button>
            <button type="button"
                    class="btn btn-default btn-cons no-margin inline"
                    data-dismiss="modal"
                    @click="$emit('close-modal')">Annuler
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import Notifications from "components/CRM/Notifications"
import CustomTextArea from "components/Forms/Elements/TextArea"
import CustomText from "components/Forms/Elements/Text"
import CustomSelect from "components/Forms/Elements/Select"

export default {
  name:"LeadDeletionModal",
  props:["lead_id", "status", "closing_reason", "closing_message", "duplicate_id"],
  components:{
    Notifications,
    CustomTextArea,
    CustomText,
    CustomSelect
  },
  data(){
    return {
      filled_closing_reason:this.closing_message,
      selected_closing_reason:this.closing_reason,
      lead_duplicate_id:this.duplicate_id
    }
  },
  mounted () {
    $(this.$el).modal()
  },
  beforeDestroy () {
    $(this.$el).modal('hide')
    $('body').removeClass('modal-open')
    $('.modal-backdrop').remove()
    this.reset_errors()
  },
  computed: {
    ...mapGetters("crm", ["is_any_errors","errors"]),
    fields()
    {
      let v = [
        {values:[
          {id:"abandonment", text:"Abandon de projet"},
          {id:"location", text:"Notre localisation"},
          {id:"take_elsewhere", text:"Prend des locaux ailleurs"},
          {id:"our_tariff", text:"Notre tarif"},
          {id:"competition", text:"Part à la concurrence"},
          {id:"annual_increase", text:"Augmentations annuelles"},
          {id:"hotline", text:"Permanence téléphonique contrat"},
          {id:"unreachable", text:"Est injoignable"},
          {id:"self_domiciliation", text:"Domiciliation à son adresse personnelle"},
          {id:"others", text:"Autres"},
        ], multiple:false, placeholder:"Séléctionner la raison principale ...", disabled:this.is_fetching, idx:0, required:true, value:this.selected_closing_reason, label:"",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:false, value:this.filled_closing_reason, label:"",type:"textarea"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:2, required:false, value:this.lead_duplicate_id, label:"",type:"text"}
      ]
      return v
    },
    normalizedErrors () {
        if (this.is_any_errors) {
            return _.flatMap(this.errors[0])
        }
    }
  },
  methods:{
    ...mapActions("crm", ["set_fetching_state", "fetch_a_lead","reset_error","reset_errors","update_lead_status"]),
    update_status() {
      this.reset_errors()
      this.set_fetching_state(true)
      this.update_lead_status({
        lead_id:this.lead_id,
        params:{
          status:this.status,
          closing_reason:this.selected_closing_reason,
          closing_message:this.filled_closing_reason,
          lead_duplicate_id:this.lead_duplicate_id
      }})
      .then(() => this.fetch_a_lead(this.lead_id))
      .then(() => this.set_fetching_state(false))
      .then(() => {
        if (!this.is_any_errors)
          this.$emit('close-modal')
      })
    }
  }
}

</script>
<style scoped>
.label {
    display: block;
    white-space: normal;
    padding: 15px 20px;
    font-size: 14px;
    text-align: left;
    line-height: 1.4rem;
    margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/LeadModal.vue